import React from "react";
import Svg, { Path } from "react-native-svg";

const CheckIcon = () => {
  return (
    <Svg width={120} height={120} viewBox="0 0 120 120" fill="none">
      <Path
        d="M41.25 61.25L53.75 73.75L78.75 48.75"
        stroke="white"
        strokeWidth={6}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M60 106.25C85.5432 106.25 106.25 85.5432 106.25 60C106.25 34.4568 85.5432 13.75 60 13.75C34.4568 13.75 13.75 34.4568 13.75 60C13.75 85.5432 34.4568 106.25 60 106.25Z"
        stroke="white"
        strokeWidth={6}
      />
    </Svg>
  );
};

export default CheckIcon;
